import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import {Layout} from '../Common';
import PrivateRoute from '../Common/PrivateRoute';
import SideNavBar from '../Common/SideNavBar';
import CustomerInquiry from './CustomerInquiry/index';
import Faq from './Faqs/index';

const menus = [
  {path: '/customer/faqs', name: 'FAQ'},
  {path: '/customer/inquiries', name: '1:1문의'},
  {path: '/customer/inquiries/submission?selectedCategory=BUSINESS_LICENSE', name: '사업자 등록증 등록'},
];

class Customer extends Component {
  render() {
    return (
      <Layout>
        <SideNavBar title="고객 센터" menus={menus} />
        <Route path="(/customer/faqs|/customer/faqs/:category/:pageNumber)" component={Faq} />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/customer/inquiries"
          component={CustomerInquiry}
        />
      </Layout>
    );
  }
}

export default Customer;
